/** API route map: URLS.Controller.Payee */
export const Payee = {
      Name: 'Payee/',
      AddPayee: 'add-payee',
      GetAllPayee: 'get-payee-details',
      DeletePayee: 'delete-payee',
      UpdatePayee: 'update-payee-details',
};
